import React from 'react';
import { Header } from '../../common/header.component';
import { useLocation } from 'react-router-dom';
import { useAddStoreCardItem } from './useAddStoreCard';
import MyLoader from '../../common/loader.component';
import { StoreCardFile } from './StoreCardFile';

export const AddStoreCard = () => {
  const { state } = useLocation() as {
    state?: { productId: string; modificationId: string };
  };

  const { data: itemInfo, isLoading: itemLoading } = useAddStoreCardItem(state);

  if (itemLoading && !itemInfo) {
    return (
      <>
        <div className="pb-4">
          <MyLoader />
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <StoreCardFile itemInfo={itemInfo} />
    </>
  );
};
